import React from 'react';
import FilterBar from '../../components/filters/FilterBar';
import { SplitMetrics } from '../../components/dashboard/metrics';
import PageLayout from '../../components/layout/PageLayout';
import ErrorBoundary from '../../components/ui/ErrorBoundary';
import { useFilterPersistence } from '../../hooks/useFilterPersistence';
import { useSettings } from '../../contexts/SettingsContext';
import { PAGE_INFO, FILTER_PERIODS } from '../../constants';
import './Splits.css';

/**
 * Splits Page Component
 * Split activity and analytics
 */
const Splits = () => {
  const { period, setPeriod } = useFilterPersistence({
    pageKey: 'splits',
    defaultPeriod: FILTER_PERIODS.ALL
  });
  const settings = useSettings();
  const compact = settings.compactMode;

  const filters = (
    <FilterBar
      period={period}
      onPeriodChange={setPeriod}
    />
  );

  return (
    <ErrorBoundary>
      <PageLayout
        title={PAGE_INFO.SPLITS.title}
        description={PAGE_INFO.SPLITS.description}
        filters={filters}
      >
        <div className="splits-content">
          <SplitMetrics period={period} compact={compact} />
        </div>
      </PageLayout>
    </ErrorBoundary>
  );
};

export default Splits;

